import type { ColumnsType } from "antd/es/table";
import { StringHelper } from "../../../../../helper";

export const useCourseColumns = () => {
  const columns: ColumnsType<any> = [
    {
      title: "STT",
      key: "stt",
      dataIndex: "stt",
    },
    {
      title: "Nghiệp vụ",
      key: "eMajor",
      dataIndex: "eMajor",
    },
    {
      title: "Môn học",
      key: "eSubject",
      dataIndex: "eSubject",
    },
    {
      title: "Khoá đào tạo",
      key: "eTrainingCourse",
      dataIndex: "eTrainingCourse",
    },
    {
      title: "Loại hình đào tạo ",
      key: "eTrainingType",
      dataIndex: "eTrainingType",
    },
    {
      title: "Học viên",
      key: "eTrainees",
      dataIndex: "eTrainees",
    },
    {
      title: "Số lượng",
      key: "eTrainingCount",
      dataIndex: "eTrainingCount",
    },
    {
      title: "Đối tượng",
      key: "eTraineeObject",
      dataIndex: "eTraineeObject",
    },
    {
      title: "Thời lượng",
      key: "eLessonTypes",
      dataIndex: "eLessonTypes",
    },
    {
      title: "Từ ngày",
      key: "eDateTime",
      dataIndex: "eDateTime",
      render: (text: string) => (
        <div>{StringHelper.verticalBarSplit<string[]>(text)[0]}</div>
      ),
    },
    {
      title: "Đến ngày",
      key: "eDateTime",
      dataIndex: "eDateTime",
      render: (text: string) => (
        <div>{StringHelper.verticalBarSplit<string[]>(text)[1]}</div>
      ),
    },
    {
      title: "Địa điểm",
      key: "eCoursePlaces",
      dataIndex: "eCoursePlaces",
    },
    {
      title: "Giáo viên/Đối tác",
      key: "eCourseTrainee",
      dataIndex: "eCourseTrainee",
    },
    {
      title: "Ghi chú",
      key: "eNotes",
      dataIndex: "eNotes",
    },
  ];
  return { columns };
};
